module.exports = __webpack_public_path__ + "static/DorothyNg-7250f65248ddbee7b9d27031d39a223e.jpg";